import DealRoomEditRouter from './EditDealRoom.router';

export { default as editDealRoutes } from './routes';

export default DealRoomEditRouter;
